export default __webpack_public_path__ + "static/media/opensea_orange.14868a37.svg";